import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { goToNextStep } from './actionCreator';
import { scrollToForm, Element } from '../../utils/scroll';

import { getStep } from './selectors';

import { Steps } from '../../components/Steps';
import Step1 from '../Step1';
import Step2 from '../Step2';
import Step3 from '../Step3';
import Step4 from '../Step4';
import Step5 from '../Step5';

class Form extends Component {
	handleSubmit = () => {
		const { goToNextStep } = this.props;
		goToNextStep();
		scrollToForm();
	};

	render() {
		const { step, t, i18n, cardType } = this.props;

		let currentStep;
		switch(step) {
			default:
			case 1:
				currentStep = <Step1 t={t} onSubmit={this.handleSubmit} cardType={cardType}></Step1>;
				break;
			case 2:
				currentStep = <Step2 t={t} i18n={i18n} onSubmit={this.handleSubmit}></Step2>;
				break;
			case 3:
				currentStep = <Step3 t={t} i18n={i18n} onSubmit={this.handleSubmit}></Step3>;
				break;
			case 4:
				currentStep = <Step4 t={t} onSubmit={this.handleSubmit}></Step4>;
				break;
			case 5:
				currentStep = <Step5 t={t}></Step5>;
				break;
		}

		return <div>
			<Element name='form_top'></Element>
			<Steps t={t} step={step}></Steps>
			{currentStep}
		</div>;
	}
}

const mapStateToProps = (state) => {
	return {
		step: getStep(state)
	};
};

const mapDispatchToProps = {
	goToNextStep
};

Form.propTypes = {
	step: PropTypes.number,
	goToNextStep: PropTypes.func,
	cardType: PropTypes.number,
	i18n: PropTypes.object,
	t: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(Form);
